import { Box, styled } from "@mui/material";

import { COLORS, TYPOGRAPHY } from "../../SignalWizard.constants";

export const Root = styled(Box)({
    position: "relative",
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100dvh",
    padding: "32px 16px",
    overflow: "hidden",
});

export const Content = styled(Box)({
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
    maxWidth: 520,
    textAlign: "center",
});

export const Logo = styled("img")(({ theme }) => ({
    display: "block",
    maxWidth: 200,
    [theme.breakpoints.down("md")]: {
        maxWidth: 160,
    },
}));

export const Title = styled("h1")(({ theme }) => ({
    margin: 0,
    color: COLORS.primary,
    ...TYPOGRAPHY.headlineLgMobile,
    [theme.breakpoints.up("md")]: {
        ...TYPOGRAPHY.display,
    },
}));

export const Subtitle = styled("p")({
    margin: "8px 0 0",
    color: COLORS.onSurfaceVariant,
    wordBreak: "break-word",
    ...TYPOGRAPHY.bodyLg,
    "& strong": { color: COLORS.primary, fontWeight: 600 },
});
